export const PROVIDER_PROFILE_CREDENTIAL_FIELDS: string[] = [
  "name",
  "address",
  "work_experience",
  "npi_number",
  "professional_education",
  "professional_training",
  "fifth_pathway_education",
  "undergraduate_education",
  "imlc_license",
  "state_medical_licenses",
  "dea",
  "cds",
  "bls",
  "acls",
  "specialty",
  "admitting_privileges",
  "professional_references",
  "healthcare_role",
  "linkedin_url",
  "ehr_system",
];
